import {StorageService} from '../../Service/StorageService';
import {UserService} from '../../Service/UserService';
import {AppSingletonUtil} from '../../Util/AppSingletonUtil';

import {BaseController} from '../BaseUI/BaseViewUI/BaseController';
import {AppMainViewComponent} from './AppMainViewComponent';

/**
 * AppMainViewController
 *
 * Viewの最上位クラスのコントローラー
 */
export class AppMainViewController extends BaseController {

	// コンポーネントとコントローラーの結合用プロパティは、継承関係上の上書きする。
	// F12での参照が出来うようにする為と、クラス構造で、どのViewと紐づくか明示する為。
	public combineView: AppMainViewComponent;

	/**
	 * constructor
	 *
	 * 本体の受取とかの初期処理
	 */
	constructor() {

		super();

	}

	/**
	 * ユーザー情報の取得
	 * @param param Viewインスタンス
	 * @returns ユーザー情報
	 */
	public async getUserInfo(param: {view: any}) {

		const svc = new UserService(param.view);
		const ret = await svc.getUserInfo();
		return ret;

	}


	/**
	 * checkUserLogin
	 * ログイン済みでトークンを設定しているかチェック
	 * @returns true: ログイン済み/false: 未ログイン
	 */
	public async checkUserLogin(param: { view: any }) {

		// ストレージにトークンがあるかチェック
		const svc = new StorageService(this);
		const isExist = await svc.isItemExist('t');

		// トークンが存在しなければログアウト
		if (!isExist) {
			return false;
		}
		// トークンを取得
		const token = await svc.getItem('t');
		if (!token) {
			// トークンの値が存在しない場合
			await svc.clear();
			return false;
		}
		AppSingletonUtil.setToken(token);

		// ユーザー情報を取得
		const userSvc = new UserService(param.view);
		const user = await userSvc.getUserInfo();
		if (!user) {
			// ユーザー情報取れない場合は終了
			await svc.clear();
			return false;
		}
		AppSingletonUtil.setUserInfo(user);

		return true;
	}


	// ログイントークンの削除
	public async deleteSavedLoginToken() {
		const svc = new StorageService(this);
		svc.clear();
	}


	/**
	 * ストレージからreferrerを取得
	 * @param view
	 */
	public async getReferrer(view: any): Promise<any> {
		// ストレージにトークンがあるかチェック
		const svc = new StorageService(this);
		const isExist = await svc.isItemExist('referrer');
		// リファラが存在しなければfalse
		if (!isExist) {
			return false;
		}

		return await svc.getItem('referrer');
	}

	public async getPaymentId(view: any): Promise<any> {
		// ストレージにトークンがあるかチェック
		const svc = new StorageService(this);
		const isExist = await svc.isItemExist('paymentId');
		// リファラが存在しなければfalse
		if (!isExist) {
			return false;
		}

		return await svc.getItem('paymentId');
	}

	/**
	 * ストレージからreferrerを削除
	 * @param view
	 */
	public async deleteReferrer(view: any): Promise<any> {
		const svc = new StorageService(this);
		return await svc.delete('referrer');
	}
}
